// This component forces a direct browser navigation to the client data page
// bypassing React Router entirely

import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export function ForceClientDataRedirect() {
  // Get the case ID from the URL parameters
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (id) {
      // Use window.location.origin to ensure it works in all environments
      const baseUrl = window.location.origin;
      const exactUrl = `${baseUrl}/client-data/${id}`;
      console.log('Force redirecting to:', exactUrl);
      
      // Force a complete browser navigation (not a React Router navigation)
      window.location.replace(exactUrl);
    }
  }, [id]);

  // Show a loading message while redirecting
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#6563ff] mx-auto mb-4"></div>
        <p className="text-lg font-medium">Redirecting to Client Data...</p>
      </div>
    </div>
  );
}
